import { useParams } from "react-router-dom";
import useLocalStorage from "@/hooks/useLocalStorage";
import { Image } from "@nextui-org/react";
import { STORAGE_LINK } from "@/utils/constants";

export default function QuizAnswers() {
    const { quizId } = useParams();
    const { getLocalStorage } = useLocalStorage();
    const apiRes = getLocalStorage(`quiz_${quizId}_results`);

    if (!apiRes?.data?.data) {
        return <></>
    }
    const quizQandA = formatQuizData(apiRes?.data.data);
    console.log(quizQandA);
    
    return (
        <div className="max-w-4xl mx-auto p-6 container mt-20 md:px-16  min-h-screen">
            {quizQandA?.map((question, index) => (
                <div key={question.id} className="mb-8">
                    <QuestionHeader question={question} index={index} />
                    <Options question={question} />

                </div>
            ))}
        </div>
    );
}

function QuestionHeader({ question, index }) {
    return <div className={`p-4 flex flex-col gap-3 rounded-lg mb-4 ${question.attributes.isCorrect ? 'bg-white border-2 border-gray-200' : 'bg-white border-2 border-red-300'}`}>
        <h2 className="text-lg font-semibold text-gray-800 text-center">
            {index + 1}- {question.attributes.question}
        </h2>
        {question.attributes.image && (
        <Image
            src={`${STORAGE_LINK}/${question.attributes.image}`}
            loading="lazy"
            alt={`question : ${question} image`}
            width={500}
            classNames={{
            wrapper: "mx-auto flex justify-center",
        }}
        />
    )}
    </div>
}

function Options({ question }) {
    const getOptionStyle = (option) => {
        const isCorrect = option.attributes.isCorrect;
        const isChosen = option.attributes.isChosen;

        if (isCorrect) {
            return {
                container: "bg-green-50 border-2 border-green-400 rounded-lg p-4 mb-3",
                text: "text-gray-800",
                badge: "bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold"
            };
        } else if (isChosen) {
            return {
                container: "bg-red-50 border-2 border-red-400 rounded-lg p-4 mb-3",
                text: "text-red-700",
                badge: "bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold"
            };
        } else {
            return {
                container: "bg-gray-100 border-2 border-gray-300 rounded-lg p-4 mb-3",
                text: "text-gray-600",
                badge: "bg-gray-400 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold"
            };
        }
    };
    return <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {question.options.map((option, index) => {
            const styles = getOptionStyle(option);
            const optionNumber = index + 1;

            return (
                <div key={option.id} className={styles.container}>
                    <div className="flex items-center justify-between">
                        <div className={styles.badge}>
                            {optionNumber}
                        </div>
                        <span className={`${styles.text} text-lg font-medium flex-1 text-right mr-4`}>
                            {option.attributes.option}
                        </span>
                    </div>
                </div>
            );
        })}
    </div>
}

const formatQuizData = (data) => {
    const formattedData = data?.map(question => {
        const processedOptions = question.options.map(option => ({
            ...option,
            attributes: {
                ...option.attributes,
                isChosen: option.id === question.attributes.chosenOptionId
            }
        }));

        return {
            ...question,
            options: processedOptions
        };
    });
    return formattedData;
};